import { useMemo } from "react";

const useAssessmentItems = () => {

    const assessmentItems = useMemo(
        () => [
            {
                title: "",
                type: "preformAssessment"
            },
            {
                title: "כניסה למבדק דרך המערכת של המורה",
                type: "preformAssessmentTable"
            },
            {
                title: "ביצוע המבדק",
                type: "preformAssessmentSteps"
            },
        ], []
    )

    return assessmentItems
}

export default useAssessmentItems